import React, { useEffect } from 'react'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'
import { connect } from 'react-redux'
import styled from 'styled-components'
import * as actions from '../actions'
import AuthModal from '../components/auth/AuthModal'
import Layout from '../components/layout/Layout'
import styles from '../constants/styles'
import allCopy from '../constants/copy'
import meta from '../constants/meta'

import { PageLoadingCircularProgress } from '../components/ambassadors/icons/CircularProgress'

const copy = allCopy.en.ambassadors.landing.hero

// eslint-disable-next-line complexity
const Login = ({
  isLoggedIn,
  isAuthModalActive,
  viewer,
  authenticating,
  handleAuthModal
}) => {
  const router = useRouter()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    if (viewer?._id && viewer?.influencer) {
      router.replace('/dashboard/home')
    }
    // TODO fix
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [viewer?._id, viewer?.influencer])

  const openAuthModal = () => {
    handleAuthModal(true)
  }

  const isLoading = isLoggedIn && !viewer._id

  return (
    <Layout specialPage meta={meta.ambassadors.login}>
      <Main>
        <Container>
          {isAuthModalActive && <AuthModal />}

          {isLoading && <PageLoadingCircularProgress />}

          {!authenticating && !viewer._id && (
            <RenderedOption option="login" openAuthModal={openAuthModal} />
          )}
          {!!viewer._id && !viewer?.influencer && (
            <RenderedOption option="unapproved" />
          )}
          {!authenticating && !isLoading && <RenderedOption option="join" />}
        </Container>
      </Main>
    </Layout>
  )
}

Login.propTypes = {
  authenticating: PropTypes.bool.isRequired,
  isAuthModalActive: PropTypes.bool.isRequired,
  handleAuthModal: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  viewer: PropTypes.objectOf(PropTypes.any)
}

Login.defaultProps = {
  viewer: {}
}

const RenderedOption = ({ option, openAuthModal }) => {
  switch (option) {
    case 'login':
      return (
        <Options>
          <Question>Are you already an Ambassador?</Question>
          <LoginButton onClick={openAuthModal}>Log In</LoginButton>
        </Options>
      )
    case 'unapproved':
      return (
        <Options>
          <Question>
            It looks like you're not an approved Ambassador yet
          </Question>
        </Options>
      )
    case 'join':
      return (
        <Options>
          <Question>Do you want to join our Ambassador Program?</Question>
          <Link href="/">
            <JoinButton>Learn More</JoinButton>
          </Link>
        </Options>
      )
    default:
      return <></>
  }
}
RenderedOption.propTypes = {
  option: PropTypes.string.isRequired,
  openAuthModal: PropTypes.func
}
RenderedOption.defaultProps = {
  openAuthModal: () => {}
}

const mapStateToProps = (state) => ({
  viewer: state.users.all[state.users.viewer._id],
  isLoggedIn: state.auth.isLoggedIn,
  authenticating: state.auth.status.authenticating,
  isAuthModalActive: state.auth.status.modalActive
})

const mapDispatchToProps = (dispatch) => ({
  handleAuthModal: (bool, isLogIn = true) => {
    dispatch({
      type: actions.HANDLE_AUTH_MODAL,
      value: bool
    })
    dispatch({
      type: actions.IS_LOG_IN,
      value: isLogIn
    })
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)

const Main = styled.main`
  width: 100%;
  max-width: 100vw;
  min-height: calc(100vh + 40px);
  margin-top: -26px;
  background-image: url(${copy.image});
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Container = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 200px;
  background-color: white;
  padding: ${styles.padding.large};
  border-radius: 30px;
  @media (max-width: 900px) {
    width: 90%;
  }
`

const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Question = styled.h2`
  color: ${styles.colors.grey};
  text-align: center;
  font-size: 1.2em;
  margin: ${styles.margin.medium};
  font-weight: 600;
  text-align: center;
  color: ${styles.colors.black};
`
const LoginButton = styled.button`
  padding: 4px 0;
  width: 160px;
  color: ${styles.colors.white};
  background-color: #2ddb7a;
  border: 2px solid #2ddb7a;
  margin-bottom: ${styles.margin.medium};
  padding: ${styles.padding.small} 0 ;
  border-radius: 24px;
  cursor: pointer;
  font-size: 1em;

  &:hover {
    background-color: ${styles.colors.white};
    color: #2ddb7a};
    border: 2px solid #2ddb7a;
  }
`

const JoinButton = styled(LoginButton)`
  background-color: #7500cb;
  border: 2px solid #7500cb;
  &:hover {
    background-color: ${styles.colors.white};
    color: #7500cb;
    border: 2px solid #7500cb;
  }
`
